/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-01-20 16:04:49
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-19 14:15:02
 */
import request from '@api/request'

// 商品类型字典集合(新版)
export const goodsTypeInfo = params =>
  request.get('/goodsSupermarket/goodsTypeInfo', { params })

// 商品类型字典集合
export const goodsTypeList = params =>
  request.get('/goodsSupermarket/goodsTypeList', { params })

// 分页查询
export const entPage = params =>
  request.get('/goodsSupermarket/pointGoodsPage', { params })

// 详情
export const entDetail = params =>
  request.get('/goodsSupermarket/entDetail', { params })

// 下订单
export const insertOrder = params =>
  request.post('/goodsOrder/insertOrder', params)

// 码上中介-我的订单列表
export const listByPage = params =>
  request.get('/goodsOrder/listByPage', { params })

// 订单详情
export const orderDetail = params =>
  request.get('/goodsOrder/orderDetail', { params })

// 企业拒绝订单
export const confirmRefuseOrder = params =>
  request.get('/goodsOrder/confirmRefuseOrder', { params })

// 商品下订单服务券列表
export const listEntCouponAll = params =>
  request.get('/entCoupon/listEntCouponAll', { params })

// 确认订单
export const confirmOrder = params =>
  request.get('/goodsOrder/confirmOrder', { params })

// 评价订单
export const evaluateOrder = params =>
  request.post('/goodsOrder/evaluateOrder', params)

// 机构详情
export const entIntermediaryOrgDetail = params =>
  request.get('/entIntermediary/entIntermediaryOrgDetail', { params })

// 机构下商品列表
export const orgGoodsPage = params =>
  request.get('/goodsSupermarket/orgGoodsPage', { params })

// 订单相关信息回显
export const entDetailInfo = params =>
  request.get('/goodsSupermarket/entDetailInfo', { params })

// 机构列表
export const entIntermediaryList = params =>
  request.get('/entIntermediary/listByPage', { params })

// 提交反馈
export const submitContent = params =>
  request.post('/goodsOrder/submitContent', params)
// 查询文件附件-移动端
export const getOperation = params =>
  request.get('/entUploadFileData/getOperation', { params })
